/*********************************************************************************************
* Class for handling variant selection
	* 
*/
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("section");
		this.addEventListener("change", this.onVariantChange);
	}

	/*********************************************************************************************
	* Handle variant change event.
		* 
	*/
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) {
				this.updateImagesVariant();
			} else {
				this.updateMedia();
			}
			this.variantFetch();
			this.syncToSecondary()
		}
	}

    syncToSecondary() {
      const secondary = document.querySelector('secondary-variant-selector');
      if (!secondary) return;
    
      const val = this.options[0];  // la valeur sélectionnée sur le principal
      const secInputs = Array.from(secondary.querySelectorAll('input[type="radio"]'));
    
      // On parcourt tous les inputs du secondary
      let matched = false;
      secInputs.forEach(input => {
        if (input.value === val) {
          input.checked = true;
          matched = true;
          // si vous voulez déclencher une sync vers le principal, vous pouvez décommenter :
          // input.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          input.checked = false;
        }
      });
    
      // Si on n'a pas trouvé de matching, on a déjà décoché tous les inputs ci-dessus.
      // (on ne fait rien de plus)
      const customTag = document.getElementById('mmCustomTagProduct');
      const customColorTag = document.getElementById('mmCustomColorTagProduct');
      const bgColor = this.querySelector(`[data-color="${val}"`).dataset.colorImg;
      
      if (matched == false) {
        customTag.classList.remove('mm-none');
        customColorTag.classList.remove('mm-none');
        customColorTag.querySelector('img').src = bgColor;
      } else {
        customTag.classList.add('mm-none');
        customColorTag.classList.add('mm-none');
      }
    }

	/*********************************************************************************************
	* Get selected options from the variant checkboxes.
		*
	*/
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	* Get variant data from the embedded JSON.
		*
		* @returns {Object} - The variant data.
	*/
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	* Get the selected variant based on selected options.
		*
	*/
	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	/*********************************************************************************************
	* Update the URL to include the selected variant ID.
		*
	*/
	updateURL() {
		window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
        document.querySelector('#product_form_selected_variant_id').value = this.currentVariant.id;
	}
	

	/*********************************************************************************************
	* Fetch variant data from the server and cache it.
		*
	*/
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
			})
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	* Render variant information in the DOM.
		*
		* @param {Document} html - The HTML document containing the variant information.
	*/
	renderVariantInfo(html) {
        const selectedInput = this.querySelector('.mm-product-variant-checkbox:checked');
        const card = selectedInput.closest('.mm-product-variant-picker-container');
      
        if (html.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container')) {
          
          const initialPrice = parseInt(html.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.initialPrice);
          const initialCompareAtPrice = parseInt(html.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.compareAtPrice);
  
          if (card.dataset.categories.includes('polarise') && document.querySelector('.mm-product-options-panel-2 button[data-category="polarise"].mm-activated') != null) {
            const polarisePrice = parseInt(document.querySelector('#product_form_option_polarise_variant_id').dataset.price);
            const newPrice = `${( initialPrice +  polarisePrice) / 100} EUR`;         
  
            html.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.price = ( initialPrice +  polarisePrice);
            html.querySelectorAll('.mm-product-options-panel-recap-price').forEach(function(elem) {
              elem.innerText = newPrice;
            })
            html.querySelectorAll('.mm-product-price').forEach(function(elem) {
              elem.innerText = newPrice;
            })
  
            const input = document.querySelector('#product_form_option_polarise_variant_id');
            if(input) {
              mmUpdateProductInputWithHandle('#product_form_option_polarise_variant_id', 'items[3]id', input.dataset.value, 'oui', input.dataset.handle);            
            }
  
            document.querySelector('.mm-product-panel-recap-listing-part-polarise').classList.remove('mm-none');
            document.querySelector('#mmShowPolarisePrice').classList.remove('mm-none');
            
          } else {
            html.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.price = initialPrice;
            html.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.compareAtPrice = initialCompareAtPrice;
            html.querySelectorAll('.mm-product-options-panel-recap-price').forEach(function(elem) {
              elem.innerText = `${ initialPrice / 100} EUR`;
            })
            html.querySelectorAll('.mm-product-price').forEach(function(elem) {
              if(initialCompareAtPrice > 0) {
                elem.innerHTML = `
                <s class="mm-product-options-panel-recap-compare-at-price text-xxs-caps mm-black-500 mm-no-wrap">${ initialCompareAtPrice / 100} EUR</s>
                <p class="mm-product-options-panel-recap-price mm-no-wrap" data-update-price-with-correction="">${ initialPrice / 100} EUR</p>
                `;                
              } else {
                elem.innerHTML = `
                <p class="mm-product-options-panel-recap-price mm-no-wrap" data-update-price-with-correction="">${ initialPrice / 100} EUR</p>
                `;                    
              }
            })
          
            const input = document.querySelector('#product_form_option_polarise_variant_id');
            if (input) {
              mmUpdateProductInputWithHandle('#product_form_option_polarise_variant_id', '', '', '', '');            
            }
  
            document.querySelector('.mm-product-panel-recap-listing-part-polarise').classList.add('mm-none');
            document.querySelector('#mmShowPolarisePrice').classList.add('mm-none');
            
          }
        }
		this.updateMultipleElement(".mm-reload", html);  
        document.dispatchEvent(new CustomEvent('reloadLazyLoad'));
        mmMediaProductSplide();

        // Enable CTAs to go next step
        const Step2CTAs = document.querySelectorAll('.mm-product-options-panel-2 .mm-product-panel-footer button');
        Step2CTAs.forEach(function(CTA) {
          CTA.disabled = false;              
        })
	}

	/*********************************************************************************************
	* Update the inner HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElementOuter(selector, html) {
		const destination = document.querySelector(`.mm-section-product ${selector}`);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of multiple elements.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateMultipleElement(selector, html) {
        // Utiliser la section produit ou document pour chercher les éléments à mettre à jour
        const productSection = document.querySelector('.mm-section-product') || document;
        const destination = productSection.querySelectorAll(selector);
        const source = html.querySelectorAll(selector);

        if (source && destination && source.length > 0 && destination.length > 0) {
            // Créer un tableau des éléments destination pour éviter les problèmes de référence
            const destArray = Array.from(destination);
            const sourceArray = Array.from(source);
            
            for (let index = 0; index < Math.min(sourceArray.length, destArray.length); index++) {
                if (destArray[index] && sourceArray[index]) {
                    destArray[index].outerHTML = sourceArray[index].outerHTML;
                }
            }
        }
    }

	/*********************************************************************************************
	* Update the media carousel to display the featured media of the current variant.
		*
	*/
	updateMedia() {
        if (this.currentVariant && this.currentVariant.featured_media && typeof splideMainProductInstance !== 'undefined' && splideMainProductInstance) {
            var variant_media_id = this.currentVariant.featured_media.id;
            var allMainMedia = document.querySelectorAll("#main-slider .splide__slide");

            allMainMedia.forEach((media, index) => {
                if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
                    splideMainProductInstance.go(index);
                }
            });
        }
    }

	/*********************************************************************************************
	* Update the visibility of the media sliders for the current variant.
		*
	*/
	updateImagesVariant() {
        var allMainMedia = document.querySelectorAll(".main-slider-variant");
        allMainMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
        var allThumbnailMedia = document.querySelectorAll(".thumbnail-slider-variant");
        allThumbnailMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
    }
}

/*********************************************************************************************
* Define the custom element
	*
*/
customElements.define("variant-selector", VariantSelector);

function resetvariant() {
  const variantSelector = document.querySelector('variant-selector');
  const changeEvent = new Event('change');

  variantSelector.dispatchEvent(changeEvent);
}

/* SYNC SECONDARY VARIANT SELECTOR */
document.addEventListener('DOMContentLoaded', () => {
  const secondary = document.querySelector('secondary-variant-selector');
  const primary   = document.querySelector('variant-selector');
  if (!secondary || !primary) return;

  // 1) Listener secondary → primary pour les vrais clics utilisateur
  const secInputs = Array.from(secondary.querySelectorAll('input[type="radio"]'));
  secInputs.forEach(secInput => {
    secInput.addEventListener('change', e => {
      if (!e.isTrusted) return;
      const val = secInput.value;
      const matching = primary.querySelector(`input[type="radio"][value="${val}"]`);
      if (!matching) return;
      matching.checked = true;
      matching.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    });
  });

  // 2) Initialisation au chargement :
  //    - si rien n'est coché dans le secondary → coche le premier
  //    - puis synchronise la valeur cochée vers le primary
  let initialSec = secondary.querySelector('input[type="radio"]:checked');
  if (!initialSec && secInputs.length > 0) {
    initialSec = secInputs[0];
    initialSec.checked = true;
  }

  if (initialSec) {
    const val = initialSec.value;
    const initialPrim = primary.querySelector(`input[type="radio"][value="${val}"]`);
    if (initialPrim) {
      initialPrim.checked = true;
      initialPrim.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
    }
  }
});





/*********************************************************************************************
* Open / Close panel
	*
*/
const PANEL_FILTER = document.querySelector('.mm-product-panel-filter');

function mmOpenPanel(index) {
  const panel = document.querySelector(`.mm-panel[data-panel="${index}"]`);
  panel.classList.add('mm-visible');
  PANEL_FILTER.classList.add('mm-visible');
  mmHideVerresImage();
  document.querySelector('#ShopifyChat')?.classList.add('mm-opacity-0');
  document.querySelector('.mm-section-header').style.zIndex = "15";
}
function mmCloseThis(button_element) {
  const panel = button_element.closest('.mm-panel');
  panel.classList.remove('mm-visible');
  mmHideVerresImage();
  mmCloseOrdoInfo();
  document.querySelector('#ShopifyChat')?.classList.remove('mm-opacity-0');
}
function mmCloseAllPanels() {
  const panels = document.querySelectorAll('.mm-panel');
  panels.forEach(function(panel) {
    panel.classList.remove('mm-visible');    
  })
  const updatePriceElements = document.querySelectorAll('[data-update-price-with-correction]');
  updatePriceElements.forEach(function(updatePriceElement) {
    const container = updatePriceElement.closest('.mm-product-options-panel-recap-price-container');
    if (container) {
      const initial_price = container.dataset.initialPrice;
      container.dataset.price = container.dataset.initialPrice;
      const euros = initial_price / 100;
      const newPriceFormated = (euros % 1 === 0)
        ? `${euros.toFixed(0)} EUR`
        : `${euros.toFixed(2)} EUR`;
      updatePriceElement.innerText = newPriceFormated;
    }
  });
  PANEL_FILTER.classList.remove('mm-visible');
  mmHideVerresImage();
  mmUpdateProductInput('#product_form_option_variant_id', '', '', '');
  mmUpdateProductInput('#product_form_option_correction_variant_id', '', '', '');
  // Reset blue light and lens package choices so an abandoned selection is not added to the cart (optic panels only)
  ['#product_form_option_variant_id_blue_light', '#product_form_option_variant_id_traitement'].forEach(function(selector) {
    if (document.querySelector(selector)) mmUpdateProductInputWithHandle(selector, '', '', '', '');
  });
  mmSetBlueLightChosen(false);
  mmRemoveFileFromInputs();
  mmClearOrdoInputs();
  mmUncheckAllButtons();
  mmCloseOrdoInfo();
  document.querySelector('#ShopifyChat')?.classList.remove('mm-opacity-0');
  setTimeout(() => {
    document.querySelector('.mm-section-header').style.zIndex = "16";
  }, "600");

  // deactivate correction inputs
  const inputs = document.querySelectorAll('.mm-product-panel-inputs input');
  inputs.forEach(function(input) {
    input.name = '';
  })

  // empty option inputs  
  const qttyInputs = document.querySelectorAll('[data-option-quantity]');
  qttyInputs.forEach(function(qttyInput) {
    qttyInput.name = '';    
  })    
}

function mmResteStep2Ctas() {  

  // Enable CTAs to go next step
  const Step2CTAs = document.querySelectorAll('.mm-product-options-panel-2 .mm-product-panel-footer button');
  Step2CTAs.forEach(function(CTA) {
    CTA.disabled = true;              
  })
  
}
function mmGoToPanel(index) {
  document.querySelector('.mm-product-options-panel-5').classList.remove('mm-visible');  
  document.querySelector('.mm-product-options-panel-4-3').classList.remove('mm-visible');  
  document.querySelector('.mm-product-options-panel-4-2').classList.remove('mm-visible');  
  document.querySelector('.mm-product-options-panel-4-1').classList.remove('mm-visible');  
  if (index == '2') {
    document.querySelector('.mm-product-options-panel-4').classList.remove('mm-visible');  
    document.querySelector('.mm-product-options-panel-3').classList.remove('mm-visible');      
    resetvariant();

    // deactivate correction inputs
    const inputs = document.querySelectorAll('.mm-product-panel-inputs input');
    inputs.forEach(function(input) {
      input.name = '';
    })
  }
  mmHideVerresImage();
  mmRemoveFileFromInputs();
  mmClearOrdoInputs();
}

function mmClearOrdoInputs() {
  const inputs = document.querySelectorAll('.mm-clear input');
  const buttons = document.querySelectorAll('button.mm-clear');

  inputs.forEach(function(input) {
    input.value = "";
    input.name = "";
  })
  buttons.forEach(function(button){
    button.disabled = true;
  })
}

function mmAddColorsWithCorrection(button) {
  const activeCards = document.querySelectorAll('.mm-product-panel-color-sup-card.mm-activated');
  activeCards.forEach(function(activeCard) {
    activeCard.querySelectorAll('[data-color-correction-input]').forEach(function(input) {
      input.name = input.dataset.name;
    })
  })

  const form = document.getElementById('product-form');
  const submitEvent = new Event('submit');
  form.dispatchEvent(submitEvent);
}

async function mmUpdatePanelVariants(product_handle) {
  const new_html = await mmgetProductSection(product_handle);
  
  if (new_html) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(new_html, "text/html");

    const newContent = doc.querySelector('.mm-product-options-panel-content variant-selector');
    const currentContent = document.querySelector('.mm-product-options-panel-content variant-selector');

    if (newContent && currentContent) {
      currentContent.innerHTML = newContent.innerHTML;
      document.dispatchEvent(new CustomEvent('reloadLazyLoad'));
      const changeEvent = new Event('change');
      document.querySelector('.mm-product-options-panel-content variant-selector').dispatchEvent(changeEvent);
    } else {
      console.error("Impossible de mettre à jour le panneau des options de produit. Élément introuvable.");
    }
  }
}

async function mmgetProductSection(product_handle) {
  const section_element = document.querySelector('.mm-section-product');
  if (!section_element) {
    console.error("Section .mm-section-product introuvable");
    return null;
  }

  const section_id = section_element.id.replace('shopify-section-', '');
  const url = `/products/${product_handle}?section_id=${section_id}`;

  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`Erreur HTTP : ${response.status}`);

    const html = await response.text();
    return html;
  } catch (error) {
    console.error("Erreur lors du fetch de la section produit:", error);
    return null;
  }
}

function mmUpdateProductInput(input_id, name, variant_id, next_input_value) {
  const input = document.querySelector(input_id);
  if (input) {
    const new_input = input.nextElementSibling;
    
    input.name = name;
    input.value = variant_id;
    new_input.value = next_input_value;    
  }
}
function mmUpdateProductInputWithHandle(input_id, name, variant_id, next_input_value, next_input_handle) {
  const input = document.querySelector(input_id);
  const new_input = input.nextElementSibling;
  const handle_input = new_input.nextElementSibling;
  
  input.name = name;
  input.value = variant_id;
  new_input.value = next_input_value;

  handle_input.value = next_input_handle;
}

function mmUpdateProductPropertyInput(input_id, name, property_value) {
  const input = document.querySelector(input_id);
  
  input.name = name;
  input.value = property_value;
}

// FILE UPLOAD
function mmInitAllDropZones() {
  document.querySelectorAll('.file-drop-wrapper').forEach(wrapper => {
    const dropZone = wrapper.querySelector('.file-drop-zone');
    const fileInput = wrapper.querySelector('.file-input');
    const icon = dropZone.querySelector('.mm-product-file-upload-icon');
    const textSpan = wrapper.querySelector('.file-name');
    const textSpan2 = wrapper.querySelector('.file-size');
    const validateBtn = wrapper.querySelector('.validate-btn');
    const fileAddedElement = wrapper.querySelector('.file-added');
    
    const downloadLinkOrdo = document.querySelector('.mm-product-panel-recap-listing-ordonnance-file a');
    const recapFileOrdo = document.querySelector('.mm-product-panel-recap-listing-ordonnance-file');
    const recapInputsOrdo = document.querySelectorAll('.mm-product-panel-recap-listing-ordonnance-inputs');
    
    const downloadLinkMut = document.querySelector('.mm-product-panel-recap-listing-mutuelle-file a');
    const recapFileMut = document.querySelector('.mm-product-panel-recap-listing-mutuelle-file');
    const recapInputsMut = document.querySelectorAll('.mm-product-panel-recap-listing-mutuelle-inputs');

    let fileURL = null;

    const updateButtonState = () => {
      const hasFile = fileInput.files.length > 0;
      validateBtn.disabled = !hasFile;
      downloadLinkOrdo.style.display = hasFile ? 'inline-block' : 'none';
      const isMut = fileInput.dataset.mutuelle == 'true';

      if (hasFile) {
        if (isMut) {
          fileInput.name = fileInput.dataset.name;
          const file = fileInput.files[0];
          if (fileURL) URL.revokeObjectURL(fileURL);
          fileURL = URL.createObjectURL(file);
          downloadLinkMut.href = fileURL;
          downloadLinkMut.download = file.name;
          downloadLinkMut.style.pointerEvents = "auto";
          downloadLinkMut.style.textDecoration = "underline";
          downloadLinkMut.innerText = "Consulter";
          recapFileMut.style.display = 'flex';
          recapInputsMut.forEach(i => i.style.display = 'none'); 
          
        } else {
          fileInput.name = fileInput.dataset.name;
          const file = fileInput.files[0];
          if (fileURL) URL.revokeObjectURL(fileURL);
          fileURL = URL.createObjectURL(file);
          downloadLinkOrdo.href = fileURL;
          downloadLinkOrdo.download = file.name;
          downloadLinkOrdo.style.pointerEvents = "auto";
          downloadLinkOrdo.style.textDecoration = "underline";
          downloadLinkOrdo.innerText = "Consulter";
          recapFileOrdo.style.display = 'flex';
          recapInputsOrdo.forEach(i => i.style.display = 'none');          
        }
      } else {
        if (isMut) {
          fileInput.name = '';
          downloadLinkMut.href = '#';
          recapFileMut.style.display = 'none';
          downloadLinkOrdo.style.textDecoration = "none";
          downloadLinkOrdo.classList.remove('mm-underline');
          recapInputsMut.forEach(i => i.style.display = 'flex');             
        } else {
          fileInput.name = '';
          downloadLinkOrdo.href = '#';
          recapFileOrdo.style.display = 'none';
          downloadLinkOrdo.style.textDecoration = "none";
          downloadLinkOrdo.classList.remove('mm-underline');
          recapInputsOrdo.forEach(i => i.style.display = 'flex');          
        }
      }
    };

    dropZone.addEventListener('click', () => fileInput.click());

    fileInput.addEventListener('change', () => {
      if (fileInput.files.length > 0) {
        fileInput.name = fileInput.dataset.name;
        const file = fileInput.files[0];
        textSpan.textContent = file.name;
        const sizeInMb = ((file.size * 8) / 1_000_000).toFixed(2);
        textSpan2.textContent = `${sizeInMb} Mb`;
        dropZone.classList.add('mm-none');
        fileAddedElement.classList.remove('mm-none');
      } else {
        fileInput.name = '';
        dropZone.classList.remove('mm-none');
        fileAddedElement.classList.add('mm-none');
        textSpan.textContent = '';
        textSpan2.textContent = '';
      }
      updateButtonState();
    });

    dropZone.addEventListener('dragover', (e) => {
      e.preventDefault();
      dropZone.classList.add('dragover');
    });

    dropZone.addEventListener('dragleave', () => {
      dropZone.classList.remove('dragover');
    });

    dropZone.addEventListener('drop', (e) => {
      e.preventDefault();
      dropZone.classList.remove('dragover');
      const files = e.dataTransfer.files;
      if (files.length > 0) {
        fileInput.name = fileInput.dataset.name;
        fileInput.files = files;
        const event = new Event("change", { bubbles: true });
        fileInput.dispatchEvent(event); // simule changement
      }
    });

    // bouton supprimer le fichier
    const removeBtn = wrapper.querySelector('.remove-file');
    if (removeBtn) {
      removeBtn.addEventListener('click', () => {
        fileInput.name = '';
        fileInput.value = '';
        const event = new Event("change", { bubbles: true });
        fileInput.dispatchEvent(event);
      });
    }

    updateButtonState(); // init
  });
}

document.addEventListener("DOMContentLoaded", mmInitAllDropZones);

function mmRemoveFileFromInputs() {
  const inputs = document.querySelectorAll('.remove-file');
  inputs.forEach(function(input) {
    const clickEvent = new Event('click');
    input.dispatchEvent(clickEvent)
  })
}

function mmAddOrRemoveName(input) {
  if (input.value.trim() !== '') {
    input.name = input.dataset.name;
  } else {
    input.name = '';
  }
}

// UPDATE FINAL RECAP
function mmUpdateTraitement(button) {
  const titleElem = document.getElementById('mm_product_panel_traitement_title');
  const priceElem = document.getElementById('mm_product_panel_traitement_price');
  const newTitle = button.querySelector('.mm-product-panel-traitement-title').innerText;
  const newPrice = button.querySelector('.mm-product-panel-traitement-price').innerText;

  titleElem.innerText = toCapitalized(newTitle);
  priceElem.innerText = newPrice;
}

// TABS VERRES COLORS
function mmVerresColorsTabs(button) {  
  const container = button.closest('[data-container]');
  const selected_category = button.dataset.category;

  // Buttons
  container.querySelectorAll('.mm-product-panel-colors-tabs-titles button').forEach(function(elem){
    elem.classList.remove('mm-activated');
  })
  button.classList.add('mm-activated');

  // Colors
  const color_elements = container.querySelectorAll('[data-color]');
  color_elements.forEach(function(color_element) {
    if (color_element.dataset.categories.includes(selected_category)) {
      color_element.classList.remove('mm-none');      
    } else {
      color_element.classList.add('mm-none');      
    }
  })
  
  //resetvariant();
  //mmAddOrRemovePolarisePrice();
}

// quand j'appuie sur on tab, j'affiche ou je masque le "+50EUR"
// quand j'appuie sur "+", j'ajoute les infos sur les inputs du produti polarisé (properties + quantité sup sur le produit polarisé)
// quand j'appuie sur "-", je retire les infos des inputs de la card + je retire la quantité sur l'input quantité du produit polarisé

function mmAddOrRemovePolarisePrice() {
  const prixPolarise = document.getElementById('mmShowPolarisePriceStep6');
  if (document.querySelector('.mm-product-options-panel-6 button[data-category="polarise"].mm-activated') != null) {
    // afficher le prix polarisé
    prixPolarise.classList.remove('mm-none');
  } else {
    // masquer le prix polarisé
    prixPolarise.classList.add('mm-none');    
  }
}

// ADD NEW COLOR
function mmProductPanelAddColor(button) {
  const card = button.closest('.mm-product-panel-color-sup-card');
  const quantitySelector = card.querySelector('[data-quantity-selector]');
  const delButton = card.querySelector('.mm-product-panel-color-sup-card-del-btn');

  const listings = document.querySelectorAll('.mm-product-options-panel-recap-subtitle');
  const color_name = card.dataset.colorName;

  const color_price = parseInt(card.dataset.colorPriceCts);
  const currentPrice = parseInt(document.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.price);
  const currentCompareAtPrice = parseInt(document.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.compareAtPrice);
  const newPrice = `${( currentPrice + color_price ) / 100} EUR`;
  const newCompareAtPrice = `${( currentCompareAtPrice + color_price ) / 100} EUR`;
  const recapPrices = document.querySelectorAll('.mm-product-options-panel-recap-price');
  const recapCompareAtPrices = document.querySelectorAll('.mm-product-options-panel-recap-compare-at-price');

  const CTAs = document.querySelectorAll('.mm-product-options-panel-6 .mm-product-panel-footer button');
  const CTAWithPrice = document.querySelector('.mm-product-options-panel-6-cta-add-w [data-cta-price]');
  const CTAWithoutPrice = document.querySelector('.mm-product-options-panel-6-cta-add-wo [data-cta-price]');
  const totalPriceWithCorrection = parseInt(document.querySelector('.mm-product-options-panel-6-cta-add-w').dataset.totalPrice);
  const totalPriceWithoutCorrection = parseInt(document.querySelector('.mm-product-options-panel-6-cta-add-wo').dataset.totalPrice);

  const inputVariantId = card.querySelector('.mm-product-panel-color-sup-variant-id-input');
  const inputVariantQuantity = card.querySelector('.mm-product-panel-color-sup-variant-qtty-input');
  const inputProductNameProperty = card.querySelector('.mm-product-panel-color-sup-product-title-input');
  const inputProductHandleProperty = document.querySelector('.mm-product-panel-color-sup-product-handle-input');
  const inputVariantIdProperty = card.querySelector('.mm-product-panel-color-sup-variant-id-input-for-main');

  const polariseMainInput = document.querySelector('#product_form_option_polarise_variant_id');
  const polariseInput = card.querySelector('.mm-product-panel-color-sup-polarise-info');
  const polariseQuantityInput = document.getElementById('product_form_option_polarise_quantity');

  // Change card
  card.classList.add('mm-activated');
  quantitySelector.value = 2;
  button.classList.add('mm-none');
  delButton.classList.remove('mm-none');

  // Add text info
  listings.forEach(function(listing) {
    listing.insertAdjacentHTML('beforeend', `<span class="text-xs-caps mm-black-500" data-color="${color_name}">, ${color_name} <span class="text-xs-caps mm-black-500" data-color-qtty></span></span>`);
  })

  // Update previousQuantity
  card.dataset.previousQuantity = quantitySelector.value;

  // Change price on recap
  recapPrices.forEach(function(recapPrice) {
    recapPrice.innerHTML = newPrice;
  })
  document.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.price = currentPrice + color_price;
  
  recapCompareAtPrices.forEach(function(recapCompareAtPrice) {
    recapCompareAtPrice.innerHTML = newCompareAtPrice;
  })
  document.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.compareAtPrice = currentCompareAtPrice + color_price;
  
  // Change price on CTA
  const correctionPrice = parseInt(card.dataset.correctionPriceCts);
  
  document.querySelector('.mm-product-options-panel-6-cta-add-w').dataset.totalPrice = totalPriceWithCorrection + color_price + correctionPrice;
  CTAWithPrice.innerHTML = `${( totalPriceWithCorrection + color_price + correctionPrice ) / 100} EUR`;
  
  document.querySelector('.mm-product-options-panel-6-cta-add-wo').dataset.totalPrice = totalPriceWithoutCorrection + color_price;
  CTAWithoutPrice.innerHTML = `${( totalPriceWithoutCorrection + color_price ) / 100} EUR`;

  // Inputs
  inputVariantId.name = inputVariantId.dataset.name;
  inputVariantQuantity.name = inputVariantQuantity.dataset.name;
  inputProductNameProperty.name = inputProductNameProperty.dataset.name;
  inputProductHandleProperty.name = inputProductHandleProperty.dataset.name;
  inputVariantIdProperty.name = inputVariantIdProperty.dataset.name;

  // Update CTAs availability
  CTAs.forEach(function(CTA) {
    CTA.disabled = false;    
  })

  // Add polarise if needed
  //if (document.querySelector('.mm-product-options-panel-6 button[data-category="polarise"].mm-activated') != null) {
    //polariseInput.value = polariseInput.dataset.value;
    //// add 2 quantity to polarise product
    //mmUpdateProductInputWithHandle('#product_form_option_polarise_variant_id', 'items[3]id', polariseMainInput.dataset.value, 'oui', polariseMainInput.dataset.handle);  
    //const currentQuantity = parseInt(polariseQuantityInput.value);
    //polariseQuantityInput.value = currentQuantity + 2;
  //}
}

function mmProductPanelDelColor(button) {
  const card = button.closest('.mm-product-panel-color-sup-card');
  const quantitySelector = card.querySelector('[data-quantity-selector]');
  const addButton = card.querySelector('.mm-product-panel-color-sup-card-add-btn');

  const listings = document.querySelectorAll('.mm-product-options-panel-recap-subtitle');
  const color_name = card.dataset.colorName;
  const previousQtty = card.dataset.previousQuantity;
  const unitPrice = card.dataset.colorPriceCts;
  const previousPrice = unitPrice;

  const color_price = parseInt(card.dataset.colorPriceCts);
  const currentPrice = parseInt(document.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.price);
  const currentCompareAtPrice = parseInt(document.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.compareAtPrice);
  const newPrice = `${( currentPrice - previousPrice ) / 100} EUR`;
  const newCompareAtPrice = `${( currentCompareAtPrice - previousPrice ) / 100} EUR`;
  const recapPrices = document.querySelectorAll('.mm-product-options-panel-recap-price');
  const recapCompareAtPrices = document.querySelectorAll('.mm-product-options-panel-recap-compare-at-price');

  const CTAs = document.querySelectorAll('.mm-product-options-panel-6 .mm-product-panel-footer button');
  const CTAWithPrice = document.querySelector('.mm-product-options-panel-6-cta-add-w [data-cta-price]');
  const CTAWithoutPrice = document.querySelector('.mm-product-options-panel-6-cta-add-wo [data-cta-price]');
  const totalPriceWithCorrection = parseInt(document.querySelector('.mm-product-options-panel-6-cta-add-w').dataset.totalPrice);
  const totalPriceWithoutCorrection = parseInt(document.querySelector('.mm-product-options-panel-6-cta-add-wo').dataset.totalPrice);

  const inputVariantId = card.querySelector('.mm-product-panel-color-sup-variant-id-input');
  const inputVariantQuantity = card.querySelector('.mm-product-panel-color-sup-variant-qtty-input');
  const inputProductNameProperty = card.querySelector('.mm-product-panel-color-sup-product-title-input');
  const inputProductHandleProperty = document.querySelector('.mm-product-panel-color-sup-product-handle-input');
  const inputVariantIdProperty = card.querySelector('.mm-product-panel-color-sup-variant-id-input-for-main');

  const polariseMainInput = document.querySelector('#product_form_option_polarise_variant_id');
  const polariseInput = card.querySelector('.mm-product-panel-color-sup-polarise-info');
  const polariseQuantityInput = document.getElementById('product_form_option_polarise_quantity');

  // Change card
  card.classList.remove('mm-activated');
  quantitySelector.value = 0;
  button.classList.add('mm-none');
  addButton.classList.remove('mm-none');

  // Add text info
  listings.forEach(function(listing) {
    listing.querySelector(`[data-color="${color_name}"]`).remove();
  })

  // Update previousQuantity
  card.dataset.previousQuantity = quantitySelector.value;

  // Change price on recap  
  recapPrices.forEach(function(recapPrice) {
    recapPrice.innerHTML = newPrice;
  })
  document.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.price = currentPrice - previousPrice;
  
  recapCompareAtPrices.forEach(function(recapCompareAtPrice) {
    recapCompareAtPrice.innerHTML = newCompareAtPrice;
  })
  document.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.compareAtPrice = currentCompareAtPrice - previousPrice;
  
  // Change price on CTA
  const correctionPrice = parseInt(card.dataset.correctionPriceCts);
  
  document.querySelector('.mm-product-options-panel-6-cta-add-w').dataset.totalPrice = totalPriceWithCorrection - previousPrice - correctionPrice;
  CTAWithPrice.innerHTML = `${( totalPriceWithCorrection - previousPrice - correctionPrice ) / 100} EUR`;
  
  document.querySelector('.mm-product-options-panel-6-cta-add-wo').dataset.totalPrice = totalPriceWithoutCorrection - previousPrice;
  CTAWithoutPrice.innerHTML = `${( totalPriceWithoutCorrection - previousPrice ) / 100} EUR`;

  // Inputs
  inputVariantId.name = "";
  inputVariantQuantity.name = "";
  inputProductNameProperty.name = "";
  inputVariantIdProperty.name = "";

  // Update CTAs availability
  if ((totalPriceWithCorrection - previousPrice - correctionPrice) == 0) {
    CTAs.forEach(function(CTA) {
      CTA.disabled = true;    
    })  
  }

  // Add polarise if needed
  //if (document.querySelector('.mm-product-options-panel-6 button[data-category="polarise"].mm-activated') != null) {
    //polariseInput.value = '';
    //// remove 2 quantity from polarise product  
    //const currentQuantity = parseInt(polariseQuantityInput.value);
    //polariseQuantityInput.value = currentQuantity - 2;
    //if (polariseQuantityInput.value == 0) {
    //  document.getElementById('product_form_option_polarise_variant_id').value = "";
    //  document.getElementById('product_form_option_polarise_variant_id').name = "";
    //}
  //}
}

// SHOW CORRECTION PRICE
function mmShowCorrectionPrice(card) {
  const price = card.dataset.correctionPrice;
  const container = card.closest('[data-container]');
  const priceContainerElem = container.querySelector('[data-correction-price-text]');
  const priceElem = priceContainerElem.querySelector('span');
  
  const imageUrl = card.dataset.image;
  const imageHtmlContainer = document.querySelector('.mm-product-panel-6-image-preview-wrapper');
  const imageHtmlElement = imageHtmlContainer.querySelector('img');

  imageHtmlContainer.classList.remove('mm-none');
  imageHtmlElement.src = imageUrl;  
  priceContainerElem.classList.remove('mm-none');
  priceElem.innerText = price;

}

function mmHideCorrectionPrice(card) {
  const container = card.closest('[data-container]');
  const priceContainerElem = container.querySelector('[data-correction-price-text]');
  
  const imageHtmlContainer = document.querySelector('.mm-product-panel-6-image-preview-wrapper');

  priceContainerElem.classList.add('mm-none');

  imageHtmlContainer.classList.add('mm-none');
}

function mmShowVerresImage(card) {  
  const imageUrl = card.dataset.image;
  const imageHtmlContainers = document.querySelectorAll('.mm-product-panel-6-image-preview-wrapper');
  const panel2 = document.querySelector('.mm-product-options-panel-2');
  
  if (panel2.classList.contains('mm-visible')) {

    imageHtmlContainers.forEach(function(imageHtmlContainer) {
      const imageHtmlElement = imageHtmlContainer.querySelector('img');
    
      imageHtmlContainer.classList.remove('mm-none');
      imageHtmlElement.classList.remove('mm-none');
      imageHtmlElement.src = imageUrl;  
    })
  }
}

function mmHideVerresImage() {  
  const imageHtmlContainers = document.querySelectorAll('.mm-product-panel-6-image-preview-wrapper');

  imageHtmlContainers.forEach(function(imageHtmlContainer) {
    imageHtmlContainer.classList.add('mm-none');  
  })
}

/* DEMO ORDONANCE */
function mmOpenOrdoInfo() {
  const modal = document.querySelector('.mm-product-panel-ordo-preview-wrapper');
  if (modal) {
    modal.classList.remove('mm-visible');
  }
}
function mmCloseOrdoInfo() {
  const modal = document.querySelector('.mm-product-panel-ordo-preview-wrapper');
  if (modal) {
    modal.classList.add('mm-visible');
  }
}

/* SEND ORDONANCE LATER */
function mmSendFileLater() {
  const recapInfo = document.querySelector('.mm-product-panel-recap-listing-ordonnance-file a');
  const recapInputsDetailsInfos = document.querySelectorAll('.mm-product-panel-recap-listing-ordonnance-inputs')

  mmUpdateProductPropertyInput('#product_form_option_send_file_later_id', 'items[0]properties[Ordonnance]', 'Envoyer plus tard');
  recapInfo.innerText = 'Envoyer plus tard';
  recapInfo.style.display = "inline-block";
  recapInfo.style.pointerEvents = "none";
  //downloadLink.style.textDecoration = "none";
  recapInfo.classList.remove("mm-underline");

  recapInputsDetailsInfos.forEach(function(recapInputsDetailsInfo) {
    recapInputsDetailsInfo.classList.add('mm-none')
  })
}

function mmValidateBtn(input) {
  const container = input.closest('[data-container');
  const inputs = container.querySelectorAll('input:required');
  const button = container.querySelector('button[type="button"]:disabled');

  // Vérifie si tous les inputs ont une valeur non vide
  const allFilled = Array.from(inputs).every(input => input.value.trim() !== '');

  // Active ou désactive le bouton en fonction
  button.disabled = !allFilled;
}

// ADD CORRECTION PRICE
function mmAddCorrectionPrice(correctionPrice) {
  const oldPrice = parseInt(document.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.price);
  const newPrice = oldPrice + parseInt(correctionPrice);

  const euros = newPrice / 100;
  const newPriceFormated = (euros % 1 === 0)
    ? `${euros.toFixed(0)} EUR`
    : `${euros.toFixed(2)} EUR`;

  const updatePriceElements = document.querySelectorAll('[data-update-price-with-correction]');
  updatePriceElements.forEach(function(updatePriceElement) {
    updatePriceElement.innerText = newPriceFormated;
  });

  document.querySelectorAll('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').forEach(function(elem) {
    elem.dataset.price = newPrice;
  })

  document.querySelector('.mm-product-options-panel-5 [data-correction-price]').innerText = `+ ${( correctionPrice / 100 )} EUR`;

  // activate correction inputs
  const inputs = document.querySelectorAll('.mm-product-panel-inputs input');
  inputs.forEach(function(input) {
    input.name = input.dataset.name;
  })
}
// ADD CORRECTION AND TRAITEMENT PRICE
function mmAddCorrectionAndTraitementPrice(traitementPrice) {
  const oldPrice = parseInt(document.querySelector('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').dataset.price);
  const newPrice = oldPrice + parseInt(traitementPrice);

  const euros = newPrice / 100;
  const newPriceFormated = (euros % 1 === 0)
    ? `${euros.toFixed(0)} EUR`
    : `${euros.toFixed(2)} EUR`;

  const updatePriceElements = document.querySelectorAll('[data-update-price-with-correction]');
  updatePriceElements.forEach(function(updatePriceElement) {
    updatePriceElement.innerText = newPriceFormated;
  });

  document.querySelectorAll('.mm-product-options-panel-recap .mm-product-options-panel-recap-price-container').forEach(function(elem) {
    //elem.dataset.price = newPrice;
    // retiré car ça causait un bug où le prix des optiosn se cumulaient quand onf aisait retour et selectionne rl'option en boucle
  })
}

// UPDATE ORDER MANUAL RECAP
function mmUpdateOrdoManualRecap() {
  const panels = document.querySelectorAll('.mm-product-panel-ordo-inputs');
  const recapValues = [];

  panels.forEach(panel => {
    const inputs = panel.querySelectorAll('input');
    let hasValue = false;
    const values = [];

    inputs.forEach(input => {
      const val = input.value.trim();
      if (val !== "") hasValue = true;
      values.push(val || ""); 
    });

    const allInputsOptional = Array.from(inputs).every(input => !input.required);
    const allEmpty = values.every(v => v === "");

    if (allInputsOptional && allEmpty) {
      recapValues.push("Non renseigné");
    } else {
      recapValues.push(values.join(", "));
    }
  });
  document.querySelector('.mm-product-panel-recap-listing-ordonnance-inputs-oeil-gauche').innerText = recapValues[0];
  document.querySelector('.mm-product-panel-recap-listing-ordonnance-inputs-oeil-droit').innerText = recapValues[1];
  document.querySelector('.mm-product-panel-recap-listing-ordonnance-inputs-ecart').innerText = recapValues[2];

  document.querySelectorAll('.mm-product-panel-recap-listing-ordonnance-inputs').forEach(function(elem) {
    elem.style.display = "flex";
  })
  document.querySelector('.mm-product-panel-recap-listing-ordonnance-file').style.display = "none";
}

function mmShowOrdonanceRecapInfos() {  
  document.querySelectorAll('.mm-product-panel-recap-listing-ordonnance-inputs').forEach(function(elem) {
    elem.style.display = "none";
  })
  document.querySelector('.mm-product-panel-recap-listing-ordonnance-file').style.display = "flex";
}

function mmSendMutuelleLater(button) {  
  const recapMutuelleElem = document.querySelector('.mm-product-panel-recap-listing-mutuelle-file');
  recapMutuelleElem.style.display = 'flex';

  const infoElem = recapMutuelleElem.querySelector('[data-info]');
  infoElem.classList.remove('mm-underline');
  infoElem.innerText = 'Envoyer plus tard';

  const input = button.nextElementSibling;
  input.name = input.dataset.name;
}

// OPTIQUES
function mmAddOptionPrice(panelIndex, optionPrice, nextIndex, updateQuantity) {

  const currentPanel = document.querySelector(`[data-panel="${panelIndex}"]`);
  const oldPrice = parseInt(currentPanel.dataset.currentPrice);
  const newPrice = oldPrice + parseInt(optionPrice);
  const nextPanel = document.querySelector(`[data-panel="${nextIndex}"]`);

  const euros = newPrice / 100;
  const newPriceFormated = (euros % 1 === 0)
    ? `${euros.toFixed(0)} EUR`
    : `${euros.toFixed(2)} EUR`;

  if(nextPanel) {
    nextPanel.dataset.currentPrice = newPrice;
  }

  const updatePriceElements = document.querySelectorAll('[data-update-price-with-correction]');
  updatePriceElements.forEach(function(updatePriceElement) {
    updatePriceElement.innerText = newPriceFormated;
  });

  if (updateQuantity) {
    const qttyInput = currentPanel.querySelector('[data-option-quantity]');
    qttyInput.name = qttyInput.dataset.name;    
  }
}

function mmCheckThisButton(button) {
  const container = button.closest('[data-container]');
  const buttons = container.querySelectorAll('button[type="button"]');

  buttons.forEach(function(button) {
    button.classList.remove('mm-active');
  })
    button.classList.add('mm-active');
}

function mmUncheckAllButtons() {
  const buttons = document.querySelectorAll('data-container button[type="button"]');  
  buttons.forEach(function(button) {
    button.classList.remove('mm-active');
  })
}

function mmUpdateRecap(button) {
  const recapOptionsElement = document.querySelector('.mm-product-panel-recap-listing-part-polarise');
  target = recapOptionsElement.querySelector(`[${button.dataset.targetRecap}]`);

  if (target) {
    titleElem = target.querySelector("[data-title]");
    priceElem = target.querySelector("[data-price]");
  }
  

  recapOptionsElement.classList.remove('mm-none');
  titleElem.innerText = toCapitalized(button.querySelector('.mm-product-panel-traitement-title').innerText);
  priceElem.innerText = button.querySelector('.mm-product-panel-traitement-price').innerText;
}

// FILTRE LUMIERE BLEUE INCLUS DANS CERTAINS FORFAITS
/**
 * Retourne le panneau filtre lumière bleue de la fiche optique (null sur les autres fiches)
 * @returns {HTMLElement|null}
 */
function mmGetBlueLightPanel() {
  return document.querySelector('[data-panel="2"][data-blue-light-price]');
}

/**
 * Mémorise le choix du panneau 2 (avec ou sans filtre), indépendamment du forfait choisi ensuite
 * @param {boolean} isChosen - true si le client a cliqué sur "Avec filtre"
 */
function mmSetBlueLightChosen(isChosen) {
  const bluePanel = mmGetBlueLightPanel();
  if (!bluePanel) return;

  bluePanel.dataset.blueLightChosen = isChosen ? 'true' : 'false';
  if (isChosen) return;

  const qttyInput = bluePanel.querySelector('[data-option-quantity]');
  if (qttyInput) qttyInput.name = '';
  mmSetBlueLightRecap('', '');
}

/**
 * Écrit la ligne filtre lumière bleue du récapitulatif (panneau 6)
 * @param {string} title - Libellé affiché
 * @param {string} price - Prix ou mention affichée
 */
function mmSetBlueLightRecap(title, price) {
  const row = document.querySelector('.mm-product-panel-recap-listing-part-polarise [data-blue-light]');
  if (!row) return;

  const titleElement = row.querySelector('[data-title]');
  const priceElement = row.querySelector('[data-price]');
  if (titleElement) titleElement.innerText = title;
  if (priceElement) priceElement.innerText = price;
}

/**
 * Au clic sur un forfait : retire le filtre choisi au panneau 2 si le forfait l'inclut, le rétablit sinon.
 * Le choix du panneau 2 n'est jamais écrasé : repasser de SMART à ESSENTIAL rétablit le filtre.
 * @param {HTMLElement|null} button - Bouton du forfait cliqué (data-includes-blue-light), null quand aucun forfait n'est retenu
 * @returns {number} Montant en centimes à déduire du prix du forfait dans le sous-total
 */
function mmApplyForfaitBlueLight(button) {
  const bluePanel = mmGetBlueLightPanel();
  if (!bluePanel) return 0;

  const isChosen = bluePanel.dataset.blueLightChosen === 'true';
  const isIncluded = !!button && button.dataset.includesBlueLight === 'true';
  const qttyInput = bluePanel.querySelector('[data-option-quantity]');
  const selector = '#product_form_option_variant_id_blue_light';

  if (isChosen && !isIncluded) {
    // Forfait sans filtre : on remet l'option choisie au panneau 2
    mmUpdateProductInputWithHandle(selector, 'items[1]id', bluePanel.dataset.blueLightVariantId, bluePanel.dataset.blueLightTitle, bluePanel.dataset.blueLightHandle);
    if (qttyInput) qttyInput.name = qttyInput.dataset.name;
    const optionButton = bluePanel.querySelector('[data-blue-light-option]');
    if (optionButton) mmUpdateRecap(optionButton);
    return 0;
  }

  // Forfait qui inclut le filtre, ou filtre non choisi : rien à envoyer au panier
  mmUpdateProductInputWithHandle(selector, '', '', '', '');
  if (qttyInput) qttyInput.name = '';

  if (isIncluded) {
    mmSetBlueLightRecap(bluePanel.dataset.blueLightLabel, bluePanel.dataset.includedText);
  } else {
    mmSetBlueLightRecap('', '');
  }

  return (isChosen && isIncluded) ? (parseInt(bluePanel.dataset.blueLightPrice) || 0) : 0;
}

/**
 * Prépare l'ajout "Je ne souhaite pas de correction" (panneau 2.1) : retire du formulaire ce qu'un retour en arrière
 * a pu y laisser (correction, affinement, forfait, ordonnance, mutuelle) et rétablit le filtre choisi au panneau 2.
 */
function mmPrepareNoCorrectionSubmit() {
  ['#product_form_option_correction_variant_id', '#product_form_option_variant_id', '#product_form_option_variant_id_traitement'].forEach(function(selector) {
    if (document.querySelector(selector)) mmUpdateProductInputWithHandle(selector, '', '', '', '');
  });
  document.querySelectorAll('[data-panel="3"] [data-option-quantity], [data-panel="3.5"] [data-option-quantity]').forEach(function(input) {
    input.name = '';
  });

  mmRemoveFileFromInputs();
  mmClearOrdoInputs();
  document.querySelectorAll('.mm-product-panel-inputs input, [data-name="items[0]properties[Mutuelle]"]').forEach(function(input) {
    input.name = '';
  });
  const sendLaterInput = document.querySelector('#product_form_option_send_file_later_id');
  if (sendLaterInput) {
    sendLaterInput.name = '';
    sendLaterInput.value = '';
  }

  mmApplyForfaitBlueLight(null);
}

document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll('.mm-product-panel-rea-splide').forEach(function(slider) {
    new Splide( slider, {
      pagination: true,
      arrows: false,
      autoplay: true,
      interval: 5000,
      perPage: 1
      }
    ).mount();                              
  })
});







